<div class="mt-1 hgap-1 align-items-start">
  <i class="vitamui-icon vitamui-icon-anomalie danger"></i>
  <mat-error class="text caption danger" [innerHTML]="getErrorMessageKey(errorKey()) | translate: translateParams()"></mat-error>
</div>
